// extracted by mini-css-extract-plugin
export default {"container":"BoardPage_container__2f4oX"};